import apiWorker from '../apiWorker'

const logs = {
    fetch : () => apiWorker('get', `/v1/api/logs`),
}

export default logs;
